import React, {useEffect, useState} from 'react';
import {connect} from "react-redux";
import {withRouter} from "../../../../utils/services/with-router";
import {CustomForm, StyledCard, StyledCountDown, StyledDiv} from "./LoginCard.styled";
import {Button, Card, Flex, Form, Input, message} from "antd";
import style from "./LoginCard.module.scss";
import {OTPProps} from "antd/es/input/OTP";
import {useNavigate} from "react-router-dom";
import {LoginOtpFormProps, ValidateOtpModel} from "../../models";
import {generateOTp, validateOTp} from "../../actions/userManagement.action";

const LoginOtpForm = ({onEdit,validateOTp,mobileNumber ,secondsLeft} :LoginOtpFormProps) => {
    const [form] = Form.useForm();
    const [timer, setTimer] = useState(120); // 120 seconds (2 minutes) for OTP countdown
    const [loading, setLoading] = useState<boolean>(false); // 120 seconds (2 minutes) for OTP countdown

    const onChange: OTPProps['onChange'] = (text) => {
        console.log(text)
        onFinish({code:text})
        form.setFieldValue('onChange:', text);
    };

    const onInput: OTPProps['onInput'] = (value) => {
    };
    const sharedProps: OTPProps = {
        onChange,
        onInput,
    };
    const onFinish = async (value: any) => {
        setLoading(true)
        let model : ValidateOtpModel={
            code:value?.code,
            mobileNumber:mobileNumber
        }
        validateOTp(model).then((data: any) => {
            setLoading(false)
            if (data.payload){
                if (data.payload?.data != null) {
                    localStorage.setItem("jwt" , data.payload.data)
                    navigate("/")
                } else message.error(data.payload.error.message)
            }
        });
    }
    const navigate = useNavigate()
    const startTimer = (count:number) => {

        setTimer(count);
        const interval = setInterval(() => {
            count -= 1;
            setTimer(count);
            if (count <= 0) {
                clearInterval(interval); // Stop timer when it reaches 0
                onEdit()
            }
        }, 1000);
    };
    useEffect(() => {
        startTimer(secondsLeft)
    }, [secondsLeft]);
    return (
        <CustomForm layout={"vertical"} onFieldsChange={(i:any) => console.log(i)} onFinish={onFinish}>
        <Flex vertical justify={"center"} gap={"large"}>
            <Form.Item
                name="code"
                label={` کد 4 رقمی که به شماره تلفن ${mobileNumber} ارسال شده است را وارد کنید`}
                rules={[
                    { required: true, message: "کد ارسال شده را وارد کنید." },
                ]}
            >
            <Input.OTP length={4} style={{direction:"ltr",display:"flex",justifyContent:"center"}}
                       formatter={(str) => str.toUpperCase()} {...sharedProps} type={"number"}/>
            </Form.Item>
           <Flex justify={"center"} vertical gap={"middle"}>
               {timer > 0 && <Flex gap={"small"} justify={"center"} align={"baseline"}>
                   <small>زمان باقی مانده : </small>
                   <StyledCountDown
                       format={"mm:ss"}
                       value={Date.now() + timer * 1000} // Pass the deadline in milliseconds
                       onFinish={() => onEdit()}
                   />
               </Flex>}
               <Button type={"primary"} loading={loading} htmlType={"submit"}>تایید</Button>
               <Button type={"text"} onClick={() => onEdit()}>ویرایش شماره موبایل</Button>
           </Flex>
        </Flex>
        </CustomForm>
    );
};

export default connect(null, {validateOTp})(withRouter(LoginOtpForm));
